import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';;

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'upload';

  create(data): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_USERS + this.model + '/create';
    let formData: FormData = new FormData();
    formData.append('image', data.image);
    formData.append('alt', data.alt);
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.post<any>(uri, formData, {headers: headers});
  }

  list(filter?): Observable<ListPhoto> {
    // check and set params of pagination
    const p = `p=${filter.page ? filter.page : 0}`;
    const s = `s=${filter.size ? filter.size : 10}`;
    const uri = _appSettings.API_ENDPOINT_USERS + this.model + `/all?${p}&${s}`;
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<ListPhoto>(uri, {headers: headers});
  }

  delete(id): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_USERS + this.model + '/' + id;
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.delete<any>(uri, {headers: headers});
  }
}

interface Photo {
  filename: string,
  alt: string,
  created_at: string,
  mimetype: string,
  destination: string,
  path: string,
  thumbnail: string,
  author: string,
  author_id: string
  id?: number
}
interface ListPhoto {
  data: Photo[],
  empty: boolean
  first: boolean
  last: boolean
  page: number
  size: number
  totalElements: number
  totalPages: number
}
